import config from 'constants/config'
import { getCompactTagVersion } from 'utils/renderHelpers'

const tagVersion = getCompactTagVersion(__TAG_VERSION__)
const WS_HANDSHAKE_TIMEOUT_MS = 10_000

export function wsHandshakeUrl(railsBaseUrl) {
  return `${railsBaseUrl.replace(/\/$/, '')}/api/v1/consumer/ws-handshake`
}

export async function fetchWsHandshakeToken(jwt) {
  const controller = new AbortController()
  const timeoutId = setTimeout(
    () => controller.abort(),
    WS_HANDSHAKE_TIMEOUT_MS
  )

  let response
  try {
    response = await fetch(wsHandshakeUrl(config.URL), {
      method: 'POST',
      signal: controller.signal,
      headers: {
        Authorization: `Bearer ${jwt}`,
        'Rightway-Consumer-Version': `AdvocateWeb/${tagVersion}`
      }
    })
  } catch (error) {
    if (error?.name === 'AbortError') {
      throw new Error(
        `ws-handshake request timed out after ${WS_HANDSHAKE_TIMEOUT_MS}ms`
      )
    }
    throw new Error(`ws-handshake network error: ${error?.message ?? error}`)
  } finally {
    clearTimeout(timeoutId)
  }

  if (!response.ok) {
    throw new Error(`ws-handshake request failed: ${response.status}`)
  }

  let body
  try {
    body = await response.json()
  } catch (error) {
    throw new Error(
      `ws-handshake response not JSON: ${error?.message ?? error}`
    )
  }

  const token = body?.token
  if (typeof token !== 'string' || !token) {
    throw new Error('ws-handshake response missing token')
  }
  return token
}

export function baseWsUrl() {
  return config.WS_URL.trim()
}

export async function buildWsUrl(jwt) {
  const token = await fetchWsHandshakeToken(jwt)
  return `${baseWsUrl()}?token=${encodeURIComponent(token)}`
}
